module.exports = __webpack_public_path__ + "img/EMT-BRCA_SpatialResearch.3a8a6206.png";